export default "/_next/static/images/ecdd5029fd468e03f941949a15f7d7c8.jpg";